import './App.css';
import React from "react";
import Main from "./main";
import Pokedex from "./pokedex";
import Adventures from "./adventures";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
const Derpwall = React.lazy(() => import("./derpwall"));
const Alerts = React.lazy(() => import("./alerts"));

function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Main />} />
        <Route exact path="/pokedex" element={<Pokedex />} />
        <Route exact path="/derpwall" element={<Derpwall />} />
        <Route exact path="/alerts" element={<Alerts />} />
        <Route exact path="/adventures" element={<Adventures />} />
      </Routes>
    </Router>
  );
}

export default App;
